import type { RouteRecordRaw } from 'vue-router'
import PageHome from '@/views/app/home/page-home.vue'
import AuthRoutes from './modules/auth'

const routes: RouteRecordRaw[] = [
  layoutApp('/home', [
    {
      path: '/',
      name: 'home',
      component: PageHome,
      meta: { title: 'Home' },
    },
    {
      path: '/riwayat-perubahan',
      name: 'changelogs',
      component: () => import('@/views/app/changelog/page-list.vue'),
      meta: { title: 'Riwayat Perubahan' },
    },
    {
      path: '/pilih-pulsa',
      name: 'select pulsa',
      component: () => import('@/views/app/purchase/1-select-service/page-pulsa.vue'),
      meta: { title: 'Pilih Pulsa' },
    },
    {
      path: '/pilih-internet',
      name: 'select internet',
      component: () => import('@/views/app/purchase/1-select-service/page-internet.vue'),
      meta: { title: 'Pilih Internet' },
    },
    {
      path: '/pilih-pln',
      name: 'select pln',
      component: () => import('@/views/app/purchase/1-select-service/page-pln.vue'),
      meta: { title: 'Pilih PLN' },
    },

    {
      path: '/konfirmasi',
      name: 'confirm purchase',
      component: () => import('@/views/app/purchase/2-confirm-payment/page-index.vue'),
      meta: { title: 'Konfirmasi' },
    },

    {
      path: '/pesanan',
      name: 'order list',
      component: () => import('@/views/app/purchase/3-list/page-list.vue'),
      meta: { title: 'Daftar Pesanan' },
    },

    {
      path: '/pesanan/:id',
      name: 'order detail',
      component: () => import('@/views/app/purchase/4-detail/page-detail.vue'),
      meta: { title: 'Detail Pesanan' },
    },

    {
      path: '/atur-harga',
      name: 'setting price',
      component: () => import('@/views/app/setting-price/page-list.vue'),
      meta: { title: 'Atur Harga' },
    },
  ]),

  AuthRoutes,
  // ErrorRoutes,
]

export function layoutApp (path: string, children: RouteRecordRaw[]): RouteRecordRaw {
  return {
    path,
    children,
    component: () => import('@/views/app/the-layout.vue'),
  }
}

export default routes
